import { useQuery } from "react-query";
import axios from "infra/http";
import { TipoAnexoContaEnum, ContaAnexo } from "core/features/conta/typings";

function useAnexosConta(id: string, tipoAnexoId: TipoAnexoContaEnum) {
  return useQuery(
    `/v1/conta/${id}/anexos/tipoAnexoId`,
    async () => {
      const { data } = await axios.get<ContaAnexo[]>(
        `/v1/conta/${id}/anexos/${tipoAnexoId}`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useAnexosConta;
